export enum DocumentDataType {
  highQualityImage = 'HIGH_QUALITY_IMAGES',
  productInfo = 'PRODUCT_INFO',
  mountingInstruction = 'MOUNTING_INSTRUCTION'
}
